import { Component } from '@angular/core';
import { soundpostAccountingEntryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Accounting Entries') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostaccountingentry-form',
    templateUrl: './soundpostaccountingentry.form.component.html'
})
export class soundpostAccountingEntryFormComponent extends BaseFormComponent {
    public record!: soundpostAccountingEntryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'accountingEntryLines', sectionName: 'Accounting Entry Lines', isExpanded: false },
            { sectionKey: 'accountingEntries', sectionName: 'Accounting Entries', isExpanded: false }
        ]);
    }
}

